export const DOMAIN_TYPE = 'glue';
